/**
 * Evaluates if the entity formation is already completed and its request status
 *
 * @param {Array} orderTasks
 * @returns {boolean} Boolean that represents if the formation has been completed
 */

export function useIsFormationCompleted(orderTasks) {
  // The only rule to check here basically is orderTaskStatus === 'incomplete'
  // If the status has any other value like 'canceled' or
  // the businessEntity has no formation order task, then the user does not need
  // to complete anything, therefore returning true
  const formationOrderData = orderTasks?.find((item) => item.orderTaskType.includes('_formation')) || null;

  if (!formationOrderData) return true;

  // Check if account is from Delaware state
  const isDelawareSCorpOrCCorp = () => (
    formationOrderData?.orderTaskJurisdiction === 'DE'
      && ['corp_formation', 's_corp_designation'].includes(formationOrderData?.orderTaskType)
  );

  // Additional logic for Delaware state
  const postPurchaseCompleteDESCorpOrCCorp = () => {
    const accountantOrderData = orderTasks?.find((item) => item.orderTaskType.includes('1800_accountant')) || false;
    return accountantOrderData && accountantOrderData?.orderTaskStatus !== 'incomplete';
  };

  // Checks if formation has been completed
  const isFormationCompleted = isDelawareSCorpOrCCorp()
    ? postPurchaseCompleteDESCorpOrCCorp()
    : formationOrderData.orderTaskStatus !== 'incomplete';

  return isFormationCompleted;
}
